<nav class="navbar navbar-expand-sm  navbar-dark bg-white border-nav fixed-top h72">
   <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar">
      <span class="navbar-toggler-icon"></span>
   </button>

   <span class="navbar-brand d-flex flex-fill">
      <button class="btn bg-blu txt-white" (click)="toggleSidebar()">
         <fa-icon aria-hidden="true" [icon]="faAlignJustify"></fa-icon>
      </button>
   </span>

   <div class="navbar-collapse collapse mt-2">
      <ul class="navbar-nav justify-content-center d-flex flex-fill custom-ul">
         <li class="nav-item">
            <a class="nav-link" routerLink="">
               <img src="{{logo}}" height="40" width="220px" alt="EBW" class="fit-img-logo">
            </a>
         </li>
         <li class="nav-item align-self-end" *ngIf="poweredBy">
            <span class="text-muted">powered by </span>
            <img src="{{poweredBy}}" ngbTooltip="EBW Orienting Business" height="23" width="100px" class alt="EBW"
               class="fit-img-powered">
         </li>
      </ul>
   </div>

   <!-- Spacer -->
   <div class="d-flex flex-fill"></div>

   <!-- User Menù -->
   <div *ngIf="userMenuActive && userInfo">
      <div class="btn-group mr-1">
         <button type="button" class="btn bg-blu txt-white" data-toggle="dropdown">
            <fa-icon class="text-white mr-2" aria-hidden="true" [icon]="faUserCircle"></fa-icon>
            <span class="font-weight-bold">{{ userInfo.name }} {{ userInfo.surname }}</span>
         </button>
         <button type="button" class="btn bg-blu txt-white dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <span class="sr-only">Toggle Dropdown</span>
         </button>
         <div class="dropdown-menu custom-dropdowm">
            <span class="dropdown-item-text userRole">
               {{userInfo.username}}
            </span>
            <div class="dropdown-divider"></div>
            <a *ngIf="userProfileActive" class="dropdown-item" routerLink="/profile"> Profilo </a>
            <a *ngIf="userLogoutActive" class="dropdown-item" (click)="onLogout()"> Logout </a>
         </div>
      </div>
   </div>
   <!-- <app-notifiche *ngIf="notificationsListActive"></app-notifiche> -->
</nav>